export default "__VITE_ASSET__Cqz2Fjfu__"